import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { useAntMedia } from 'providers/AntMediaProvider'
import { useRussianPokerStore } from 'providers/RussianPokerProvider'
import { FC, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { TopActionBar, Typography } from 'rpComponents'

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding-right: 120px;
`

const ContainerTop = styled.div`
  position: absolute;
  z-index: 10;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledVideo = styled.video`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: 0;
`

const VIDEO_ID = 'videoRussianPoker'

const RpVideoStream: FC = observer(() => {
  const ref = useRef<HTMLVideoElement | null>(null)
  const {
    game,
    uiStore: { volume },
  } = useRussianPokerStore()
  const { t } = useTranslation()
  const { play, cleanupStream, connectionState, streamState } = useAntMedia()

  if (!game) return null

  const streamId = game.config.stand.stream.id

  useEffect(() => {
    return () => {
      cleanupStream()
    }
  }, [])

  useEffect(() => {
    if (connectionState === 'ready' && streamId && ref.current) {
      play(streamId, ref.current)
    }
  }, [connectionState, streamId, play])

  useEffect(() => {
    if (ref.current) {
      ref.current.volume = volume
      if (volume > 0) {
        ref.current.muted = false
      }
    }
  }, [volume])

  return (
    <Container>
      <ContainerTop>
        <TopActionBar />
      </ContainerTop>

      <StyledVideo ref={ref} autoPlay muted playsInline id={VIDEO_ID} />
      {(streamState === 'streamNotFound' || connectionState === 'error') && (
        <Overlay>
          <Typography variant="head1" color="white">
            {t('noSignal')}
          </Typography>
        </Overlay>
      )}
    </Container>
  )
})

export default RpVideoStream
